import { getShareShowNickNameSwitch } from "@/api/member";
import { getCommonShareInfo2 } from "@/api/share";
import { formatImgUrl } from "@/utils/crop";
import { wxShare } from "@/utils/wx-share";
import { Toast } from "antd-mobile";
import Cookie from "js-cookie";
import { useCallback, useState } from "react";

export default function useShareLive({ liveType, shopId }) {
  const [showSharePoster, setShowSharePoster] = useState(false);

  /**
   * 根据spm,查询并配置分享信息
   */
  const shareLiveLink = useCallback(
    (liveInfoResp = {}, shareTitle) => {
      if (Number(liveType) === 20 || !liveInfoResp.isCanShare) {
        wxShare({}, true);
        return;
      }
      getCommonShareInfo2({
        urlParams: {
          convert: "on",
          spm: liveInfoResp.spm,
          from: "qrcode",
          invUserCode: Cookie.get("msUserCode") || "",
        },
        params: {
          shareType: liveInfoResp.shareType || "LIVEING",
          shareOnlyId: liveInfoResp.liveNo,
          channelType: "H5MALL",
          authLink: true,
        },
      }).then(shareRes => {
        if (shareRes.code === 200 && shareRes.success) {
          const shareData = shareRes.data;
          const { activityList = [], coverUrl = "" } = liveInfoResp;
          let title = "";
          if (activityList && activityList.length > 0) {
            title = activityList[0].brandName;
          }
          // 配置微信分享信息，点击微信浏览器右下角分享按钮时用到
          wxShare({
            title: `${title} ${shareTitle}`,
            desc: "大牌直播特卖，天天上新",
            link: shareData.shareLink,
            imgUrl: coverUrl,
          });
        }
      });
    },
    [liveType],
  );

  return {
    showSharePoster,
    setShowSharePoster,
    shareLiveLink,
  };
}
